import { useMemo } from 'react';
import { propagateSats, type SatPosition, type TrackedSat } from '@/lib/satellites';
import { useNow } from '@/hooks/useNow';
import type { GeoPoint } from '@/lib/geo';

/** Current positions of all tracked satellites, recomputed every 5 s. */
export function useSatellitePositions(
  tles: TrackedSat[] | undefined,
  location: GeoPoint,
  enabled: boolean,
): SatPosition[] {
  const now = useNow(5_000);
  return useMemo(() => {
    if (!enabled || !tles || tles.length === 0) return [];
    return propagateSats(tles, now, location);
  }, [tles, now, location, enabled]);
}
